import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-divider',
  templateUrl: './chat-divider.component.html',
  styleUrls: ['./chat-divider.component.scss']
})
export class ChatDividerComponent implements OnInit {

  @Input() label: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
